const state = {
    isCheckToken: null,
    apiHost: null,
    userInfo: null,
    leftMenuNav: [],
    userInfo: null,
    name: 'weish',
    age: 22,
    send_userinfo: null,
    personl: [],
    activeIndex: window.sessionStorage.getItem('activeIndex') || 0,
    changData: null,
    query_search: null,
    questionChange: null,
    delQuestion: null,
    isItcScene: 2, // 1: K12版; 2: 高教版
    customerKeyword: null,
    customerCate: null,
};

export default state;